import Header from "../components/Header";
import Footer from "../components/Footer";

function handleClick(link) {
  const win = window.open(link, '_blank');
  win.focus();
}

function handleCite(citation) {
  const filename = "BIBTEXCitationExport.txt";

  const blob = new Blob([citation], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

const citationA = `
@article{HELP,
  author = {Juricev-Martincev,Filip and Giuffrida,Bernadette and Thompson,Mery and White,Gentry},
  title = {A novel hierarchical aggregation algorithm for optimal repartitioning of statistical regions},
  journal = {International Journal of Geographical Information Science},
  year = {2023},
  doi = {10.1080/13658816.2023.2204347},
  }
`


const citationB = `
@article{HELP2,
  author = {Juricev-Martincev,Filip and Thompson,Mery and White,Gentry},
  title = {Emulating human expertise in rezoning: a case study of the Australian statistical geography standard},
  journal = {Australian Geographer},
  volume = {0},
  number = {0},
  pages = {1--29},
  year = {2024},
  publisher = {Routledge},
  doi = {10.1080/00049182.2024.2434277}
  }
`

const citationC = `
@article{HELP,
  author = {Juricev-Martincev,Filip and Thompson,Mery and White,Gentry},
  title = {Geographical Rezoning as a Combinatorial Game: Case Study of the Australian Statistical Geography Standard},
  journal = {Journal of Official Statistics},
  year = {2026},
  doi = {10.1177/0282423X261429706},
  }
`

export default function Publications() {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="bg-topography flex-grow flex flex-col items-center justify-center gap-y-4">

        <div className="w-full flex justify-center">
          <div className="animate-slide-in-right p-6 w-full md:max-w-4xl rounded-xl bg-transparent border border-accent shadow-lg flex flex-col sm:flex-row items-center gap-6 sm:gap-10">
            {/* SCImago Image */}
            <a href="https://www.scimagojr.com/journalsearch.php?q=12134&;tip=sid&;exact=no" title="SCImago Journal Country Rank" className="shrink-0">
            <img border="0" src="https://www.scimagojr.com/journal_img.php?id=12134" alt="SCImago Journaland Country Rank" className="w-24 sm:w-32 rounded-lg" />
            </a>


            {/* Publication Details and Buttons */}
            <div className="flex flex-col items-center sm:items-start text-center sm:text-left flex-grow w-full">
              <div className="mb-4">
                <h2 className="text-base md:text-xl font-bold text-text">
                  Geographical Rezoning as a Combinatorial Game: Case Study of the Australian Statistical Geography Standard
                </h2>
                <h3 className="text-sm md:text-lg font-semibold text-text">
                  Journal of Official Statistics
                </h3>
                <p className="text-xs md:text-lg font-semibold text-text">
                  2026
                </p>
              </div>

              {/* Buttons */}
              <div className="w-full h-auto grid grid-cols-1 sm:grid-cols-2 gap-4">
                <button
                  onClick={() => handleClick("https://journals.sagepub.com/doi/10.1177/0282423X261429706")}
                  className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-lg focus:ring-4 focus:outline-none bg-green-600 hover:bg-green-700 focus:ring-green-800 transition-colors duration-200"
                >
                  Read article
                  <svg aria-hidden="true" className="w-4 h-4 ml-2 -mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path>
                  </svg>
                </button>
                <button
                  onClick={() => handleCite(citationC)}
                  className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-lg focus:ring-4 focus:outline-none bg-blue-600 hover:bg-blue-700 focus:ring-blue-800 transition-colors duration-200"
                >
                  Cite paper
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 ml-2 -mr-1">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Second Publication Card */}
        <div className="w-full flex justify-center">
          <div className="animate-slide-in-right p-6 w-full md:max-w-4xl rounded-xl bg-transparent border border-accent shadow-lg flex flex-col sm:flex-row items-center gap-6 sm:gap-10">
            {/* SCImago Image */}
            <a href="https://www.scimagojr.com/journalsearch.php?q=27511&tip=sid&exact=no" title="SCImago Journal & Country Rank" className="shrink-0">
              <img src="https://www.scimagojr.com/journal_img.php?id=27511" alt="SCImago Journal & Country Rank" className="w-24 sm:w-32 rounded-lg" />
            </a>

            {/* Publication Details and Buttons */}
            <div className="flex flex-col items-center sm:items-start text-center sm:text-left flex-grow w-full">
              <div className="mb-4">
                <h2 className="text-base md:text-xl font-bold text-text">
                  Emulating human expertise in rezoning: a case study of the Australian statistical geography standard
                </h2>
                <h3 className="text-sm md:text-lg font-semibold text-text">
                  Australian Geographer
                </h3>
                <p className="text-xs md:text-lg font-semibold text-text">
                  2024
                </p>
              </div>

              {/* Buttons */}
              <div className="w-full h-auto grid grid-cols-1 sm:grid-cols-2 gap-4">
                <button
                  onClick={() => handleClick("https://www.tandfonline.com/doi/abs/10.1080/00049182.2024.2434277")}
                  className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-lg focus:ring-4 focus:outline-none bg-green-600 hover:bg-green-700 focus:ring-green-800 transition-colors duration-200"
                >
                  Read article
                  <svg aria-hidden="true" className="w-4 h-4 ml-2 -mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path>
                  </svg>
                </button>
                <button
                  onClick={() => handleCite(citationB)}
                  className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-lg focus:ring-4 focus:outline-none bg-blue-600 hover:bg-blue-700 focus:ring-blue-800 transition-colors duration-200"
                >
                  Cite paper
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 ml-2 -mr-1">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* First Publication Card */}
        <div className="w-full flex justify-center">
          <div className="animate-slide-in-left p-6 w-full md:max-w-4xl rounded-xl bg-transparent border border-accent shadow-lg flex flex-col sm:flex-row items-center gap-6 sm:gap-10">
            {/* SCImago Image */}
            <a href="https://www.scimagojr.com/journalsearch.php?q=28040&tip=sid&exact=no" title="SCImago Journal & Country Rank" className="shrink-0">
              <img src="https://www.scimagojr.com/journal_img.php?id=28040" alt="SCImago Journal & Country Rank" className="w-24 sm:w-32 rounded-lg" />
            </a>

            {/* Publication Details and Buttons */}
            <div className="flex flex-col items-center sm:items-start text-center sm:text-left flex-grow w-full">
              <div className="mb-4">
                <h2 className="text-base md:text-xl font-bold text-text">
                  A novel hierarchical aggregation algorithm for optimal repartitioning of statistical regions
                </h2>
                <h3 className="text-sm md:text-lg font-semibold text-text">
                  International Journal of Geographical Information Science
                </h3>
                <p className="text-xs md:text-lg font-semibold text-text">
                  2023
                </p>
              </div>

              {/* Buttons */}
              <div className="w-full h-auto grid grid-cols-1 sm:grid-cols-2 gap-4">
                <button
                  onClick={() => handleClick("https://www.tandfonline.com/doi/full/10.1080/13658816.2023.2204347")}
                  className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-lg focus:ring-4 focus:outline-none bg-green-600 hover:bg-green-700 focus:ring-green-800 transition-colors duration-200"
                >
                  Read article
                  <svg aria-hidden="true" className="w-4 h-4 ml-2 -mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path>
                  </svg>
                </button>
                <button
                  onClick={() => handleCite(citationA)}
                  className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-lg focus:ring-4 focus:outline-none bg-blue-600 hover:bg-blue-700 focus:ring-blue-800 transition-colors duration-200"
                >
                  Cite paper
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 ml-2 -mr-1">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

      </main>
      <Footer />
    </div>
  );
}
